import { render, staticRenderFns } from "./DraftLettersList.vue?vue&type=template&id=caf43dc0"
import script from "./DraftLettersList.vue?vue&type=script&lang=js"
export * from "./DraftLettersList.vue?vue&type=script&lang=js"
import style0 from "./DraftLettersList.vue?vue&type=style&index=0&id=caf43dc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports